module.exports = __webpack_public_path__ + "static/media/LoaderLogo.3e5054f3.gif";